module.exports = __webpack_public_path__ + "static/media/Artboard11.863306dc.png";